"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdTrackEventShadow = void 0;
/* eslint-disable */
const track_request_1 = require("../../../../../ads/request/track_request");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../../../google/protobuf/wrappers");
function createBaseAdTrackEventShadow() {
    return {
        event: undefined,
        userAgentOverride: undefined,
        clientIpOverride: undefined,
    };
}
exports.AdTrackEventShadow = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.event?.$case === "trackRequest") {
            track_request_1.TrackRequest.encode(message.event.trackRequest, writer.uint32(10).fork()).ldelim();
        }
        if (message.userAgentOverride !== undefined) {
            wrappers_1.StringValue.encode({ value: message.userAgentOverride }, writer.uint32(18).fork()).ldelim();
        }
        if (message.clientIpOverride !== undefined) {
            wrappers_1.StringValue.encode({ value: message.clientIpOverride }, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdTrackEventShadow();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.event = {
                        $case: "trackRequest",
                        trackRequest: track_request_1.TrackRequest.decode(reader, reader.uint32()),
                    };
                    break;
                case 2:
                    message.userAgentOverride = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.clientIpOverride = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdTrackEventShadow();
        if (object.event?.$case === "trackRequest" &&
            object.event?.trackRequest !== undefined &&
            object.event?.trackRequest !== null) {
            message.event = {
                $case: "trackRequest",
                trackRequest: track_request_1.TrackRequest.fromPartial(object.event.trackRequest),
            };
        }
        message.userAgentOverride = object.userAgentOverride ?? undefined;
        message.clientIpOverride = object.clientIpOverride ?? undefined;
        return message;
    },
};
//# sourceMappingURL=track_event_shadow.js.map